import { Component, computed, DestroyRef, inject, input, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Facet, FacetAlias } from 'app/my-history/facet/facet';
import { FacetService } from 'app/my-history/facet/facet.service';
import { ValueAccessorDirective } from 'app/shared/form/value-accessor.directive';
import { FacetPillsComponent } from 'app/my-history/facet/facet-pills/facet-pills.component';

@Component({
  selector: 'app-facet-selection',
  standalone: true,
  imports: [FacetPillsComponent],
  templateUrl: './facet-selection.component.html',
  styleUrl: './facet-selection.component.scss',
  host: {
    class: 'block',
  },
  hostDirectives: [ValueAccessorDirective],
})
export class FacetSelectionComponent implements OnInit {
  hideDescription = input(false)
  withDescription = input(false);
  defaultSelectedFacet = input<FacetAlias | undefined>();
  facetType = input<'all' | 'user' | 'userNoChapter'>('user');
  selectedFacetChanged = output<Facet>();

  private valueAccessor = inject(ValueAccessorDirective);
  private facetService = inject(FacetService);
  private destroyRef = inject(DestroyRef);
  private _selectedFacet = signal<FacetAlias | null>(null);
  readonly selectedFacet = computed(() => {
    // TODO refresh facet filter and set default selected faset
    // if (this.facetService.userFacetTypes().some((f) => f.alias !== this._selectedFacet())) {
    //   return FacetAlias.chapter;
    // }
    return this._selectedFacet() ? this._selectedFacet() : this.defaultSelectedFacet();
  });
  readonly facets = computed(() => {
    if (this.facetType() === 'user') {
      return this.facetService.userFacetTypes();
    }
    if (this.facetType() === 'userNoChapter') {
      return this.facetService.userNoChapterFacetTypes();
    }
    return this.facetService.allFacetTypes();
  });

  ngOnInit(): void {
    if (this.facetType() === 'all') {
      this.facetService.getAllFacetTypes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    } else {
      this.facetService.getUserFacetTypes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
  }

  setSelectedFacet(facet: Facet | null): void {
    if (!facet) return;
    this._selectedFacet.set(facet.alias);
    if (facet) {
      this.selectedFacetChanged.emit(facet);
    }

    this.valueAccessor.valueChange([facet.id]);
    this.valueAccessor.touchedChange(true);
  }

  onFilter(facet: Facet | null): void {
    this.setSelectedFacet(facet);
  }
}
